import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import termsPdf from "../../assets/pdf/terms.pdf";
import "./TermsOfUse.scss";

// Use the worker copied from public/ so the URL is stable after deployment.
const pdfWorkerPath = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerPath;

const TermsOfUse = () => {
  const [numPages, setNumPages] = useState<number>(0);

  return (
    <div className="terms-of-use-container" data-testid="terms-of-use-container">
      <Document
        file={termsPdf}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        className="terms-of-use-document"
      >
        {Array.from({ length: numPages }, (_, i) => (
          <Page key={i + 1} pageNumber={i + 1} className="terms-of-use-page" />
        ))}
      </Document>
    </div>
  );
};

export default TermsOfUse;
